export default "__VITE_ASSET__CNK1RaKm__"